import { render } from "./makeNotificationAsRead.vue?vue&type=template&id=07750676"
import script from "./makeNotificationAsRead.vue?vue&type=script&lang=js"
export * from "./makeNotificationAsRead.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__